import styled from 'styled-components';

const Spacer = styled.div<{ width?: number; height?: number }>`
  display: ${(props) => (!props.height ? 'inline-block' : 'block')};
  ${(props) => (props.width ? { width: props.width } : undefined)}
  ${(props) => (props.height ? { height: props.height } : undefined)}
`;

export default Spacer;
